<div class="payments-data">
  <div class="payments-data__header">
    <h2>{{ 'NEW_CONTRACTS.PAYMENT_DATA' | i18nextEager }}</h2>
    <span class="compulsory">* {{ 'COMMONS.REQUIRED' | i18nextEager }}</span>
  </div>
  <form [formGroup]="addressForm" *ngIf="addressForm">
    <section>
      <h2>{{ 'NEW_CONTRACTS.NOTIFICATION_ADDRESS' | i18nextEager }} *</h2>
      <div class="payments-data__notification">
        <div class="radios">
          <span (click)="toggleAddress(0)">
            <img *ngIf="!businessSelected" src="/assets/icons/radio-default.svg" alt="" />
            <img *ngIf="businessSelected" src="/assets/icons/radio-select.svg" alt="" />
            {{ 'NEW_CONTRACTS.TO_BUSINESS_ADDRESS' | i18nextEager }}
          </span>
          <span (click)="toggleAddress(1)">
            <img *ngIf="!installationSelected" src="/assets/icons/radio-default.svg" alt="" />
            <img *ngIf="installationSelected" src="/assets/icons/radio-select.svg" alt="" />
            {{ 'NEW_CONTRACTS.TO_INSTALATION_ADDRESS' | i18nextEager }}
          </span>
          <span (click)="toggleAddress(2)">
            <img *ngIf="!otherSelected" src="/assets/icons/radio-default.svg" alt="" />
            <img *ngIf="otherSelected" src="/assets/icons/radio-select.svg" alt="" />
            {{ 'NEW_CONTRACTS.TO_OTHER_ADDRESS' | i18nextEager }}
          </span>
        </div>
        <div *ngIf="!otherSelected">
          <div class="row">
            <div class="addressInfo">
              <span class="addressInfo__label">{{ 'NEW_CONTRACTS.ROAD_TYPE' | i18nextEager }}</span>
              <span class="addressInfo__field">{{ dataToShow?.nombreTipoViaDireccion }}</span>
            </div>
            <div class="addressInfo">
              <span class="addressInfo__label">{{ 'NEW_CONTRACTS.ROAD_NAME' | i18nextEager }}</span>
              <span class="addressInfo__field">{{ dataToShow?.nombreDireccion }}</span>
            </div>
            <div class="addressInfo"></div>
            <div class="addressInfo"></div>
            <div class="addressInfo"></div>
          </div>
          <div class="row">
            <div *ngIf="dataToShow?.numeroDireccion" class="addressInfo">
              <span class="addressInfo__label">{{ 'NEW_CONTRACTS.ADDRESS_NUMBER' | i18nextEager }}</span>
              <span class="addressInfo__field">{{ dataToShow?.numeroDireccion }}</span>
            </div>
            <div *ngIf="dataToShow?.portalDireccion" class="addressInfo">
              <span class="addressInfo__label">{{ 'NEW_CONTRACTS.ADDRESS_GATE' | i18nextEager }}</span>
              <span class="addressInfo__field">{{ dataToShow?.portalDireccion }}</span>
            </div>
            <div *ngIf="dataToShow?.escaleraDireccion" class="addressInfo">
              <span class="addressInfo__label">{{ 'NEW_CONTRACTS.ADDRESS_STAIR' | i18nextEager }}</span>
              <span class="addressInfo__field">{{ dataToShow?.escaleraDireccion }}</span>
            </div>
            <div *ngIf="dataToShow?.pisoDireccion" class="addressInfo">
              <span class="addressInfo__label">{{ 'NEW_CONTRACTS.ADDRESS_FLOOR' | i18nextEager }}</span>
              <span class="addressInfo__field">{{ dataToShow?.pisoDireccion }}</span>
            </div>
            <div *ngIf="dataToShow?.puertaDireccion" class="addressInfo">
              <span class="addressInfo__label">{{ 'NEW_CONTRACTS.ADDRESS_DOOR' | i18nextEager }}</span>
              <span class="addressInfo__field">{{ dataToShow?.puertaDireccion }}</span>
            </div>
          </div>
          <div class="row">
            <div *ngIf="dataToShow?.nombrePoblacionDireccion" class="addressInfo">
              <span class="addressInfo__label">{{ 'NEW_CONTRACTS.TOWN' | i18nextEager }}</span>
              <span class="addressInfo__field">{{ dataToShow?.nombrePoblacionDireccion }}</span>
            </div>
            <div *ngIf="dataToShow?.codPostalDireccion" class="addressInfo">
              <span class="addressInfo__label">{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</span>
              <span class="addressInfo__field">{{ dataToShow?.codPostalDireccion }}</span>
            </div>
            <div class="addressInfo"></div>
            <div class="addressInfo"></div>
            <div *ngIf="dataToShow?.nombreProvinciaDireccion" class="addressInfo">
              <span class="addressInfo__label">{{ 'NEW_CONTRACTS.PROVINCE' | i18nextEager }}</span>
              <span class="addressInfo__field">{{ dataToShow?.nombreProvinciaDireccion }}</span>
            </div>
          </div>
        </div>
        <div *ngIf="otherSelected">
          <app-custom-select
            class="width100"
            [label]="'NEW_CONTRACTS.ROAD_TYPE'"
            [required]="true"
            [controlName]="'roadType'"
            [values]="roadTypeList"
            [defaultValue]="defaultValueRoadType"
            [searchBar]="true"
          ></app-custom-select>

          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.ROAD_NAME' | i18nextEager }}</mat-label>
            <input matInput formControlName="roadName" maxlength="100" />
          </mat-form-field>

          <div class="tree-col">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_NUMBER' | i18nextEager }}</mat-label>
                <input matInput formControlName="number" maxlength="8" alphanumeric />
                <mat-error
                  *ngIf="
                    addressForm?.get('number').errors?.maxlength &&
                    (addressForm?.get('number').touched || addressForm?.get('number').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.EIGHT_CHARACTERS_ERROR' | i18nextEager }}
                </mat-error>
                <mat-error
                  *ngIf="
                    !addressForm?.get('number').errors?.maxlength &&
                    addressForm?.get('number').errors?.invalidInitialValue &&
                    (addressForm?.get('number').touched || addressForm?.get('number').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_GATE' | i18nextEager }}</mat-label>
                <input matInput formControlName="gate" maxlength="10" />
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_STAIR' | i18nextEager }}</mat-label>
                <input matInput formControlName="stair" maxlength="3" alphanumeric />
                <mat-error
                  *ngIf="
                    addressForm?.get('stair').errors?.maxlength &&
                    (addressForm?.get('stair').touched || addressForm?.get('stair').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
                </mat-error>
                <mat-error
                  *ngIf="
                    !addressForm?.get('stair').errors?.maxlength &&
                    addressForm?.get('stair').errors?.invalidInitialValue &&
                    (addressForm?.get('stair').touched || addressForm?.get('stair').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="tree-col">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_FLOOR' | i18nextEager }}</mat-label>
                <input matInput formControlName="floor" maxlength="3" alphanumeric />
                <mat-error
                  *ngIf="
                    addressForm?.get('floor').errors?.maxlength &&
                    (addressForm?.get('floor').touched || addressForm?.get('floor').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
                </mat-error>
                <mat-error
                  *ngIf="
                    !addressForm?.get('floor').errors?.maxlength &&
                    addressForm?.get('floor').errors?.invalidInitialValue &&
                    (addressForm?.get('floor').touched || addressForm?.get('floor').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_DOOR' | i18nextEager }}</mat-label>
                <input matInput formControlName="door" maxlength="3" alphanumeric />
                <mat-error
                  *ngIf="
                    addressForm?.get('door').errors?.maxlength &&
                    (addressForm?.get('door').touched || addressForm?.get('door').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
                </mat-error>
                <mat-error
                  *ngIf="
                    !addressForm?.get('door').errors?.maxlength &&
                    addressForm?.get('door').errors?.invalidInitialValue &&
                    (addressForm?.get('door').touched || addressForm?.get('door').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field *ngIf="isUserSpain" appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</mat-label>
                <input matInput formControlName="postalCode" />
                <mat-error
                  *ngIf="
                    addressForm?.controls.postalCode.errors?.required &&
                    (addressForm.controls.postalCode.touched || addressForm.controls.postalCode.dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>
              <div *ngIf="!isUserSpain">
                <div class="payments-data__pt-postal-code-field">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</mat-label>
                    <input matInput formControlName="postalCodePT1" maxlength="4" />
                  </mat-form-field>
                  <p class="payments-data__postal-code-hyphen">
                    {{ 'NEW_CONTRACTS.POSTAL_CODE_PT_HYPHEN' | i18nextEager }}
                  </p>
                  <mat-form-field appearance="outline">
                    <input matInput formControlName="postalCodePT2" maxlength="3" />
                  </mat-form-field>
                </div>
                <mat-error
                  *ngIf="
                    (addressForm?.controls.postalCodePT1.errors?.required ||
                      addressForm?.controls.postalCodePT2.errors?.required) &&
                    (addressForm.controls.postalCodePT1.touched ||
                      addressForm.controls.postalCodePT1.dirty ||
                      addressForm.controls.postalCodePT2.touched ||
                      addressForm.controls.postalCodePT2.dirty)
                  "
                  class="payments-data__pt-postal-code-error"
                >
                  {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                </mat-error>
                <mat-error
                  *ngIf="
                    !addressForm?.controls.postalCodePT1.errors?.required &&
                    !addressForm?.controls.postalCodePT2.errors?.required &&
                    addressForm?.controls.postalCode.errors?.pattern &&
                    (addressForm.controls.postalCodePT1.touched ||
                      addressForm.controls.postalCodePT1.dirty ||
                      addressForm.controls.postalCodePT2.touched ||
                      addressForm.controls.postalCodePT2.dirty)
                  "
                  class="payments-data__pt-postal-code-error"
                >
                  {{ 'NEW_CONTRACTS.POSTAL_CODE_ERROR' | i18nextEager }}
                </mat-error>
              </div>
            </div>
          </div>
          <ng-container *ngIf="townList.length < 1; else selectTemplate">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'NEW_CONTRACTS.TOWN' | i18nextEager }}</mat-label>
              <input matInput formControlName="town" maxlength="100" />
              <mat-error
                *ngIf="
                  addressForm?.controls.town.errors?.required &&
                  (addressForm.controls.town.touched || addressForm.controls.town.dirty)
                "
              >
                {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </ng-container>
          <ng-template #selectTemplate>
            <app-custom-select
              class="width100"
              [label]="'NEW_CONTRACTS.TOWN'"
              [controlName]="'town'"
              [values]="townList"
              [defaultValue]="defaultValueTown"
            >
              <mat-error
                *ngIf="
                  addressForm?.controls.town.errors?.required &&
                  (addressForm.controls.town.touched || addressForm.controls.town.dirty)
                "
              >
                {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
              </mat-error>
            </app-custom-select>
          </ng-template>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.PROVINCE' | i18nextEager }}</mat-label>
            <input
              matInput
              formControlName="province"
              maxlength="100"
              placeholder="{{ 'NEW_CONTRACTS.PROVINCE_EXAMPLE' | i18nextEager }}"
            />
            <mat-error
              *ngIf="
                addressForm?.controls.province.errors?.required &&
                (addressForm.controls.province.touched || addressForm.controls.province.dirty)
              "
            >
              {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </section>
  </form>

  <form [formGroup]="paymentForm" *ngIf="addressForm">
    <section>
      <h2>{{ 'NEW_CONTRACTS.SIGNATURE_DATA' | i18nextEager }}</h2>
      <div class="payments-data__signature">
        <div class="check">
          <mat-checkbox (change)="toggleAutocomplete($event)">
            {{ 'NEW_CONTRACTS.AUTOFILL' | i18nextEager }}
          </mat-checkbox>
        </div>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_CONTRACTS.NAME' | i18nextEager }}</mat-label>
          <input matInput formControlName="name" maxlength="50" />
          <mat-error
            *ngIf="
              paymentForm?.controls.name.errors?.required &&
              (paymentForm.controls.name.touched || paymentForm.controls.name.dirty)
            "
          >
            {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_CONTRACTS.SURNAME' | i18nextEager }}</mat-label>
          <input matInput formControlName="surname" maxlength="50" />
          <mat-error
            *ngIf="
              paymentForm?.controls.surname.errors?.required &&
              (paymentForm.controls.surname.touched || paymentForm.controls.surname.dirty)
            "
          >
            {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_CONTRACTS.DNI_NIE' | i18nextEager }}</mat-label>
          <input
            matInput
            formControlName="dni"
            placeholder="{{ isUserSpain ? ('NEW_CONTRACTS.DNI_EXAMPLE' | i18nextEager) : '' }}"
          />
          <mat-error
            *ngIf="
              paymentForm?.controls.dni.errors?.required &&
              (paymentForm.controls.dni.touched || paymentForm.controls.dni.dirty)
            "
          >
            {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
          </mat-error>
          <mat-error
            *ngIf="
              paymentForm?.controls.dni.errors?.invalid_dni &&
              (paymentForm.controls.dni.touched || paymentForm.controls.dni.dirty)
            "
          >
            {{ 'NEW_CONTRACTS.DNI_ERROR' | i18nextEager }}
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_CONTRACTS.EMAIL' | i18nextEager }}</mat-label>
          <input
            matInput
            formControlName="email"
            [placeholder]="'NEW_CONTRACTS.EMAIL_EXAMPLE' | i18nextEager"
            maxlength="50"
          />
          <mat-error
            *ngIf="
              paymentForm?.controls.email.errors?.required &&
              (paymentForm.controls.email.touched || paymentForm.controls.email.dirty)
            "
          >
            {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
          </mat-error>
          <mat-error
            *ngIf="
              paymentForm?.controls.email.errors &&
              paymentForm?.controls.email.value &&
              (paymentForm.controls.email.touched || paymentForm.controls.email.dirty)
            "
          >
            {{ 'NEW_CONTRACTS.EMAIL_ERROR' | i18nextEager }}
          </mat-error>
        </mat-form-field>
        <div class="payments-data__mobile-field">
          <div *ngIf="!isUserSpain" class="payments-data__country-code">
            <app-custom-select
              [required]="true"
              [label]="'NEW_CONTRACTS.MOBILE_COUNTRY_CODE.LABEL'"
              [controlName]="'mobileCountryCode'"
              [values]="mobileCountryCodeList"
              [disabled]="paymentForm.get('mobileCountryCode').disabled"
              [defaultValue]="paymentForm.get('mobileCountryCode').value"
            ></app-custom-select>
          </div>
          <div class="payments-data__mobile-input">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'NEW_CONTRACTS.MOBILE' | i18nextEager }}</mat-label>
              <input matInput formControlName="mobile" maxlength="9" numeric />
              <mat-error
                *ngIf="
                  (paymentForm?.controls.mobile.errors?.required ||
                    paymentForm?.controls.mobile.errors?.invalid_mobile) &&
                  (paymentForm.controls.mobile.touched || paymentForm.controls.mobile.dirty)
                "
              >
                {{ 'NEW_CONTRACTS.MOBILE_ERROR' | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </section>
    <section *ngIf="isUserSpain">
      <h2>{{ 'NEW_CONTRACTS.BANK_ACCOUNT' | i18nextEager }} *</h2>
      <div class="payments-data__account">
        <mat-form-field appearance="outline" id="iban">
          <mat-label>{{ 'NEW_CONTRACTS.IBAN' | i18nextEager }}</mat-label>
          <input
            matInput
            uppercase
            id="ibanInput"
            formControlName="iban"
            maxlength="4"
            (paste)="onPasteIBAN($event)"
            (keyup)="bankAccountKeyUp($event, null, 'ibanInput', 'entityInput')"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" id="entity">
          <mat-label>{{ 'NEW_CONTRACTS.ENTITY' | i18nextEager }}</mat-label>
          <input
            matInput
            numeric
            id="entityInput"
            formControlName="entity"
            maxlength="4"
            (paste)="onPasteIBAN($event)"
            (keyup)="bankAccountKeyUp($event, 'ibanInput', 'entityInput', 'officeInput')"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" id="office">
          <mat-label>{{ 'NEW_CONTRACTS.OFFICE' | i18nextEager }}</mat-label>
          <input
            matInput
            numeric
            id="officeInput"
            formControlName="office"
            maxlength="4"
            (paste)="onPasteIBAN($event)"
            (keyup)="bankAccountKeyUp($event, 'entityInput', 'officeInput', isUserSpain ? 'dcInput' : 'accountInput')"
          />
        </mat-form-field>
        <mat-form-field *ngIf="isUserSpain" appearance="outline" id="dc">
          <mat-label>{{ 'NEW_CONTRACTS.DC' | i18nextEager }}</mat-label>
          <input
            matInput
            numeric
            id="dcInput"
            formControlName="dc"
            maxlength="2"
            (paste)="onPasteIBAN($event)"
            (keyup)="bankAccountKeyUp($event, 'officeInput', 'dcInput', 'accountInput')"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" id="account">
          <mat-label>{{ 'NEW_CONTRACTS.ACCOUNT' | i18nextEager }}</mat-label>
          <input
            matInput
            numeric
            id="accountInput"
            formControlName="account"
            [maxlength]="isUserSpain ? 10 : 11"
            (paste)="onPasteIBAN($event)"
            (keyup)="
              bankAccountKeyUp(
                $event,
                isUserSpain ? 'dcInput' : 'officeInput',
                'accountInput',
                isUserSpain ? null : 'dcInput'
              )
            "
          />
        </mat-form-field>
        <mat-form-field *ngIf="!isUserSpain" appearance="outline" id="dc">
          <mat-label>{{ 'NEW_CONTRACTS.DC' | i18nextEager }}</mat-label>
          <input
            matInput
            numeric
            id="dcInput"
            formControlName="dc"
            maxlength="2"
            (paste)="onPasteIBAN($event)"
            (keyup)="bankAccountKeyUp($event, 'accountInput', 'dcInput', null)"
          />
        </mat-form-field>
      </div>
      <div
        class="payments-data__account__error"
        *ngIf="
          paymentForm?.hasError('invalid_IBAN') &&
          (paymentForm.controls.iban.touched ||
            paymentForm.controls.iban.dirty ||
            paymentForm.controls.entity.touched ||
            paymentForm.controls.entity.dirty ||
            paymentForm.controls.office.touched ||
            paymentForm.controls.office.dirty ||
            paymentForm.controls.dc.touched ||
            paymentForm.controls.dc.dirty ||
            paymentForm.controls.account.touched ||
            paymentForm.controls.account.dirty)
        "
      >
        <mat-error>
          {{ 'NEW_CONTRACTS.IBAN_ERROR' | i18nextEager }}
        </mat-error>
      </div>
    </section>
  </form>
</div>
